import gql from "graphql-tag";

export const CHARACTERISTIC_DATA_TYPES_QUERY = gql`
  query CharacteristicDataTypes { 
    characteristicDataTypes
  }
`
